import React from 'react';

const DefaultingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.08" cx="12" cy="12" r="12" fill="#912018" />
    <path d="M13.5148 13.312V16H10.6448V13.312H13.5148ZM13.6548 5.878L12.9408 12.374H11.2748L10.5048 5.878H13.6548Z" fill="#912018" />
  </svg>

);
export default DefaultingIcon;
